import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService, ButtonLoader, ConfigService, FormsUtilsService, MessageService } from '../../../../core';
import { ConfigPedido } from '../../../configuracoes/app/pedido';
import { PedidoFilter } from '../../filter';
import { PedidoExcelHttpService } from '../services';
import { PedidoExcelListagemOptions } from './pedido-excel-listagem-options';

@Component({
    selector: 'sgt-pedido-excel-listagem-modal',
    templateUrl: './pedido-excel-listagem-modal.component.html',
    styleUrls: ['./pedido-excel-listagem-modal.component.less']
})
export class PedidoExcelListagemModalComponent implements OnInit {
    configPedido: ConfigPedido;
    isAdministrador: boolean;
    isAtendente: boolean;
    isExpedicao: boolean;
    isRepresentante: boolean;

    elModal: any;
    @ViewChild('form') form: NgForm;
    nomeExportacao: string;
    private filter: PedidoFilter;
    private orderBy: number;
    private orderByDir: string;

    /** Options */
    options: PedidoExcelListagemOptions;
    // Empresas (Para exibir as opções conforme a empresa) TODO: Melhorar isto para não precisar verificar a empresa
    isRafitec: boolean;
    isPropex: boolean;

    constructor(private el: ElementRef,
                private authService: AuthService,
                private configService: ConfigService,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private pedidoExcelHttpService: PedidoExcelHttpService) { }

    ngOnInit() {
        this.configPedido = this.configService.getPedido();
        this.isAdministrador = this.authService.isAdministrador();
        this.isAtendente = this.authService.isAtendente();
        this.isExpedicao = this.authService.isExpedicao();
        this.isRepresentante = this.authService.isRepresentante();
        this.isRafitec = this.authService.isRafitec();
        this.isPropex = this.authService.isPropex();

        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#nomeExportacao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(filter: PedidoFilter, orderBy: number, orderByDir: string) {
        this.filter = filter;
        this.orderBy = orderBy;
        this.orderByDir = orderByDir;
        this.nomeExportacao = null;
        this.options = this.createOptions();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Verifica se é a empresa Rafitec ou Propex */
    isRafitecOuPropex(): boolean {
        return this.isRafitec || this.isPropex;
    }


    /** Cria as opções da exportação */
    private createOptions(): PedidoExcelListagemOptions {
        const options = new PedidoExcelListagemOptions();

        // Rafitec ou Propex
        if (this.isRafitecOuPropex()) {
            options.exportValorIpi = true; // Valor do IPI
            options.exportStatusAmostra = true; // Status da Amostra
        }

        return options;
    }

    /** Valida os dados para realizar a exportação */
    private validateExport(): boolean {
        // Sem nome da exportação
        if (!this.nomeExportacao) {
            this.messageService.info('Informe o nome da exportação para poder exportar', 'Informação');
            jQuery(this.elModal).find('#nomeExportacao').focus();
            return false;
        }

        // Form inválido
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false;
        }

        return true;
    }

    /** Realiza a exportação da listagem dos pedidos para Excel */
    export() {
        if (!this.validateExport()) {
            return false;
        }

        const btn = new ButtonLoader('#btnExportPedidoListagem');
        btn.loading('Exportando');
        this.pedidoExcelHttpService.exportListagem(this.nomeExportacao, this.filter, this.orderBy, this.orderByDir, this.options)
            .then(() => {
                btn.reset();
                this.close();
            })
            .catch(() => {
                this.messageService.error('Ocorreu um erro ao exportar os pedidos para Excel. Tente novamente', 'Erro ao exportar');
                btn.reset();
            });
    }
}
